module.exports = __webpack_public_path__ + "img/amex.a187af91.svg";